/**** 折线图类型 ****/
const LINE = Symbol('折线');
const GRIDENT = Symbol('折线渐变');
const LINE_TYPE = { LINE, GRIDENT };

/**** 错误信息 ****/
const ERROR_TEXT = Symbol('No Data');
const ERROR_IMAGE = Symbol('No Data');
const ERROR_TYPE = { ERROR_TEXT, ERROR_IMAGE };

/**** MA5,MA10,MA20,MA30,MA60,MA60 ****/
const KLINE_MA5 = 5;
const KLINE_MA10 = 10;
const KLINE_MA20 = 20;
const KLINE_MA30 = 30;
const KLINE_MA60 = 60;
const KLINE_MA120 = 120;
const KLINE_MATYPE = { KLINE_MA5, KLINE_MA10, KLINE_MA20, KLINE_MA30, KLINE_MA60, KLINE_MA120 };
/**** 分时五档明细 ****/
const TREND_WD = Symbol('五档');
const TREND_MX = Symbol('明细');
const TREND_CJ = Symbol('成交');
const TREND_TYPE = { TREND_WD, TREND_MX, TREND_CJ };
/**** 组件状态 ****/
const TREND_ONE = 10;//分时
const TREND_FIVE = 11;//五日
const KLINE_ONEMIN = 1;//一分钟
const KLINE_FIVEMIN = 2;//5分钟
const KLINE_FIFMIN = 3;//15分钟
const KLINE_THIMIN = 4;//30分钟
const KLINE_SIXMIN = 5;//60分钟
const KLINE_ONEDAY = 6;//一天
const KLINE_ONEWEEK = 7;//一周
const KLINE_ONEMONTH = 8;//一个月
const KLINE_ONEYEAR = 9;//一年

/**** 主视图状态 ****/
const TREND_KEY = 1;
const MA_KEY = 2;
const JZ_KEY = 4;
const KD_KEY = 8;
const HH_KEY = 16; // 鸿鹄震荡视图Key
const BOLL_KEY = 32; // BOLL线key
const AREA_KEY = 64;
// const MAIN_KLINE = [
//   { key: MA_KEY, context: KLineMADectorator(KLineState), text: '均线', noauth: true },
//   { key: JZ_KEY, context: KLineJQJZDectorator(KLineState), text: '鲸奇9转', noauth: true },
//   { key: KD_KEY, context: KLineKDDectorator(KLineState), text: 'KD密码', noauth: true },
//   { key: BOLL_KEY, context: KLineBOLLDectorator(KLineState), text: 'BOLL', noauth: true }
//   // {key: HH_KEY, context: KLineSwanDectorator(KLineState), text: '鸿鹄震荡', noauth: true},
// ];

/**** 组件各部分的状态映射 ****/
/**** 辅视图状态 ****/
const AMOUNT_KEY = 1;
const MACD_KEY = 2;
const KDJ_KEY = 4;
const ENE_KEY = 8;
const ELECTRIC_KEY = 16;
const FUNDFLOW_KEY = 32;
const FUNDFLOWDIR_KEY = 64;
const DMA_KEY = 128;
const VR_KEY = 256;
const WR_KEY = 512;
const OBV_KEY = 1024;
const DMI_KEY = 2048;
const RSI_KEY = 4096;
const PSY_KEY = 8192;
const LIANGBI_KEY = 16384;

const KEY_MAP = {
  TREND_KEY,
  MA_KEY,
  JZ_KEY,
  KD_KEY,
  HH_KEY,
  BOLL_KEY,
  AREA_KEY,
  AMOUNT_KEY,
  MACD_KEY,
  PSY_KEY,
  RSI_KEY,
  DMI_KEY,
  OBV_KEY,
  WR_KEY,
  VR_KEY,
  DMA_KEY,
  LIANGBI_KEY,
  KDJ_KEY,
  ENE_KEY,
  ELECTRIC_KEY,
  FUNDFLOW_KEY,
  FUNDFLOWDIR_KEY,
};


export {
  LINE_TYPE,
  ERROR_TYPE,
  KLINE_MATYPE,
  TREND_TYPE,
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,
  KEY_MAP  
}
